// import React, { useState, useEffect, useCallback } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useToast,
//    Text,
//    Flex,
// } from '@chakra-ui/react';
// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import { useDispatch, useSelector } from 'react-redux';
// import { getCompanyDetailsByGst, addCompanyInUI, updateCompany, getCompanies } from '../../../redux/actions/company';
// // import { getCities } from '../../../redux/actions/city';
// import { getGroupIDs } from '../../../redux/actions/companyGroup';
// import './css.css';
// import { userProfile } from '../../../redux/actions/user';
// import { useGlobal } from '../../../contexts/GlobalContext';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { DynamicInput } from '../../../components/UIcomponents/Dynamicinput';
// import { renderSwitchControl } from 'utils/DynamicFormData';
// import { Box } from 'lucide-react';

// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Company Name is required'),
//    panNo: Yup.string()
//       .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
//       .required('PAN is required'),
//    address1: Yup.string().required('Address 1 is required'),
//    cityId: Yup.mixed().required('City is required'),
//    // Optional fields - make all of these accept empty strings, null or undefined
//    gstRegNo: Yup.string()
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    mobile: Yup.string()
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    email: Yup.string()
//       .email('Invalid email format')
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    address2: Yup.string()
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    address3: Yup.string()
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    pincode: Yup.string()
//       .transform((value) => (value === '' ? null : value))
//       .nullable(),
//    coGroupId: Yup.mixed().nullable(),
// });

// const CompanyForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, gstNo }) => {
//    //   const [activeStep, setActiveStep] = useState(0);
//    const { cityList } = useGlobal();
//    const [errors, setErrors] = useState({});
//    const textColor = useColorModeValue('gray.800', 'white');
//    // const gstNo = localStorage.getItem('gst');
//    const coGroupIds = useSelector((state) => state.companyGroup.list);
//    // const cities = useSelector((state) => state.city.list);
//    const company = useSelector((state) => state.company.gstDetail);

//    const toast = useToast();
//    const dispatch = useDispatch();

//    const [row, setRow] = useState({
//       name: '',
//       panNo: '',
//       gstRegNo: '',
//       mobile: '',
//       email: '',
//       address1: '',
//       address2: '',
//       address3: '',
//       isCRM: false,
//       cityId: null,
//       pincode: '',
//       coGroupId: null,
//       bankAccName1: null,
//       bankAccName2: null,
//       bankAccNo1: null,
//       bankAccNo2: null,
//       bankIFSC1: null,
//       bankIFSC2: null,
//       bankName1: null,
//       bankName2: null,
//    });

//    const clearFormData = () => {
//       setRow({
//          name: '',
//          panNo: '',
//          gstRegNo: '',
//          mobile: '',
//          email: '',
//          address1: '',
//          address2: '',
//          address3: '',
//          cityId: null,
//          pincode: '',
//          isCRM: false,
//          coGroupId: null,
//          bankAccName1: null,
//          bankAccName2: null,
//          bankAccNo1: null,
//          bankAccNo2: null,
//          bankIFSC1: null,
//          bankIFSC2: null,
//          bankName1: null,
//          bankName2: null,
//       });
//       setErrors({});
//    };

//    const handleOnClose = () => {
//       clearFormData();
//       localStorage.removeItem('gst');
//       window.location.reload();
//       onClose();
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({ ...prev, [field]: value }));

//       if (field === 'gstRegNo' && value?.toString()?.length === 15) {
//          setRow((prev) => ({ ...prev, panNo: value?.slice(2, 12) }));
//          dispatch(getCompanyDetailsByGst(value));
//       }

//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const validateStep = async () => {
//    //   try {
//    //     await validationSchema.validate(row, { abortEarly: false });
//    //     setErrors({});
//    //     return true;
//    //   } catch (err) {
//    //     if (err instanceof Yup.ValidationError) {
//    //       const errorObj = {};
//    //       err.inner.forEach((error) => {
//    //         errorObj[error.path] = error.message;
//    //       });
//    //       setErrors(errorObj);
//    //       return false;
//    //     }
//    //     return false;
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       try {
//          const processedData = {
//             ...row,
//          };

//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             await dispatch(updateCompany(processedData));
//          } else {
//             await dispatch(addCompanyInUI(processedData));
//          }
//          await dispatch(getCompanies());
//          await dispatch(userProfile());
//          clearFormData();
//          onClose();
//          // window.location.reload();
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Daybook.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     onFormSubmit();
//    //   } else {
//    //     toast({
//    //       title: 'Validation Error',
//    //       description: 'Please correct the errors.',
//    //       status: 'error',
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    const handleNext = () => {
//       try {
//          // Manually prepare the data to handle nulls
//          const dataToValidate = {};

//          // Copy only the required fields for validation
//          dataToValidate.name = row.name || '';
//          dataToValidate.panNo = row.panNo || '';
//          dataToValidate.address1 = row.address1 || '';
//          dataToValidate.cityId = row.cityId !== null && row.cityId !== undefined ? row.cityId : '';

//          // Validate synchronously
//          const isValid = validationSchema.validateSync(dataToValidate, { abortEarly: false });

//          if (isValid) {
//             onFormSubmit();
//          }
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);

//             toast({
//                title: 'Validation Error',
//                description: 'Please correct the errors.',
//                status: 'error',
//                duration: 3000,
//                isClosable: true,
//             });
//          }
//       }
//    };

//    // const hasFetched = useRef(false);

//    useEffect(() => {
//       if (gstNo) {
//          dispatch(getCompanyDetailsByGst(gstNo)); // Call only once
//       }
//    }, [gstNo, dispatch]);

//    // const getCompanyDetailsByGST = useCallback(
//    //    async (gst) => {
//    //       dispatch(getCompanyDetailsByGst(gst));
//    //    },
//    //    [dispatch],
//    // );

//    // useEffect(() => {
//    //    if (gstNo) {
//    //       getCompanyDetailsByGST(gstNo);
//    //    }
//    // }, [getCompanyDetailsByGST, gstNo]);

//    useEffect(() => {
//       if (coGroupIds?.length <= 0 && isOpen) {
//          dispatch(getGroupIDs());
//       }
//    }, [coGroupIds?.length, dispatch, isOpen]);

//    // useEffect(() => {
//    //   if (cities?.length <= 0 && isOpen) {
//    //     dispatch(getCities());
//    //   }
//    // }, [cities?.length, dispatch, isOpen]);

//    useEffect(() => {
//       if (company) {
//          const address = company && company.pradr ? company.pradr.addr : {};
//          const gstUpper = (gstNo || '').toUpperCase(); // ✅ Ensure uppercase
//          setRow((prev) => ({
//             ...prev,
//             name: company?.tradeNam,
//             gstRegNo: row.gstRegNo || gstUpper,
//             address1: `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`,
//             cityId: cityList?.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id,
//             coGroupId : coGroupIds?.find((group) => group?.name?.toLowerCase() === (company?.lgnm || '').toLowerCase())?.id,
//             pincode: address?.pncd,
//             panNo: gstUpper?.slice(2, 12),
//          }));
//       }
//    }, [cityList, company, gstNo]);

//    useEffect(() => {
//       if (isOpen && isEditMode && currentRow) {
//          setRow((prev) => ({
//             ...prev,
//             name: currentRow?.name,
//             panNo: currentRow?.panNo,
//             gstRegNo: currentRow?.gstRegNo ?? '',
//             mobile: currentRow?.mobile,
//             email: currentRow?.email,
//             address1: currentRow?.address1,
//             address2: currentRow?.address2,
//             address3: currentRow?.address3,
//             cityId: currentRow?.cityId,
//             pincode: currentRow?.pinCode,
//             coGroupId: currentRow?.coGroupId,
//             isCRM: currentRow?.isCRM,
//             bankAccName1: currentRow?.bankAccName1,
//             bankAccName2: currentRow?.bankAccName2,
//             bankAccNo1: currentRow?.bankAccNo1,
//             bankAccNo2: currentRow?.bankAccNo2,
//             bankIFSC1: currentRow?.bankIFSC1,
//             bankIFSC2: currentRow?.bankIFSC2,
//             bankName1: currentRow?.bankName1,
//             bankName2: currentRow?.bankName2,
//          }));
//       }
//    }, [currentRow, isEditMode, isOpen]);

//    const handleSwitchChange = (field) => (event) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: event.target.checked, // Updates boolean value (true/false)
//       }));
//    };

//    return (
//       <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" closeOnEsc={false}>
//          <ModalOverlay />
//          <ModalContent
//             // bg={useColorModeValue('white', '#2d3748')}
//             // color={useColorModeValue('gray.800', 'white')}
//             tabIndex={0} // ✅ Makes it focusable to catch key events
//             onKeyDown={(e) => {
//                if (e.key === 'Escape') {
//                   e.preventDefault();
//                   window.location.reload();
//                }
//             }}
//             height="auto"
//             maxHeight="90%"
//             my="2%"
//             borderRadius="20px"
//             p={5}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" p={0} mb={4}>
//                {isEditMode ? 'Edit Company' : 'Add New Company'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody overflowY="scroll">
//                <Grid
//                   h="auto"
//                   //   templateRows="repeat(2, 1fr)"
//                   //   templateColumns="repeat(5, 1fr)"
//                   gap={4}>
//                   {/* <GridItem rowSpan={2} colSpan={1}>
//                 <Stepper
//                   index={activeStep}
//                   orientation="vertical"
//                   colorScheme="teal"
//                 >
//                   {steps.map((step, index) => (
//                     <Step key={index}>
//                       <StepIndicator>
//                         <StepStatus
//                           complete={<StepIcon />}
//                           incomplete={<StepNumber />}
//                           active={<StepNumber />}
//                         />
//                       </StepIndicator>
//                       <Box flexShrink="1">
//                         <StepTitle>{step.title}</StepTitle>
//                         <StepDescription>{step.description}</StepDescription>
//                       </Box>
//                       <StepSeparator />
//                     </Step>
//                   ))}
//                 </Stepper>
//               </GridItem> */}
//                   <GridItem colSpan={4}>
//                      <Grid
//                         templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
//                         gap={2}>
//                         <>
//                            {/* {gstNo && isEditMode && ( */}
//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'gstRegNo',
//                                  'GST NO',
//                                  {
//                                     value: row.gstRegNo,
//                                     onChange: (e) => handleInputChange('gstRegNo', e.target.value.toUpperCase()),
//                                  },
//                                  errors,
//                                  textColor,
//                                  'text',
//                                  false,
//                               )}
//                            </GridItem>
//                            {/* )} */}

//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'name',
//                                  'Company Name',
//                                  {
//                                     value: row.name,
//                                     onChange: (e) => handleInputChange('name', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  'text',
//                                  true,
//                               )}
//                            </GridItem>
//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'panNo',
//                                  'Pan No',
//                                  {
//                                     value: row.panNo,
//                                     onChange: (e) => handleInputChange('panNo', e.target.value.toUpperCase()),
//                                  },
//                                  errors,
//                                  textColor,
//                                  'text',
//                                  true,
//                               )}
//                            </GridItem>
//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'mobile',
//                                  'Mobile',
//                                  {
//                                     value: row.mobile,
//                                     onChange: (e) => handleInputChange('mobile', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                               )}
//                            </GridItem>
//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'email',
//                                  'email',
//                                  {
//                                     value: row.email,
//                                     onChange: (e) => handleInputChange('email', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'address1',
//                                  'Address 1',
//                                  {
//                                     value: row.address1,
//                                     onChange: (e) => handleInputChange('address1', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  'text',
//                                  true, // isRequired
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'address2',
//                                  'Address 2',
//                                  {
//                                     value: row.address2,
//                                     onChange: (e) => handleInputChange('address2', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'address3',
//                                  'Address 3',
//                                  {
//                                     value: row.address3,
//                                     onChange: (e) => handleInputChange('address3', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {renderDynamicDropdown(
//                                  'city',
//                                  'City',
//                                  cityList,
//                                  {
//                                     value: row.cityId,
//                                     onChange: (value) => handleInputChange('cityId', value),
//                                     showCustomNoOptions: true,
//                                     openfrom: 'city',
//                                  },
//                                  errors,
//                                  textColor,
//                                  true, // isRequired
//                                  'Select City', // placeholder
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {DynamicInput(
//                                  'pincode',
//                                  'Pincode',
//                                  {
//                                     value: row.pincode,
//                                     onChange: (e) => handleInputChange('pincode', e.target.value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                               )}
//                            </GridItem>

//                            <GridItem className="seperator-width">
//                               {renderDynamicDropdown(
//                                  'coGroupId',
//                                  'Group ID',
//                                  coGroupIds,
//                                  {
//                                     value: row.coGroupId,
//                                     onChange: (value) => handleInputChange('coGroupId', value),
//                                  },
//                                  errors,
//                                  textColor,
//                                  false, // isRequired
//                                  'Select Company Group', // placeholder
//                               )}
//                            </GridItem>
//                            <GridItem className="seperator-width">
//                               {renderSwitchControl(
//                                  'isCRM',
//                                  'is Allow CRM',
//                                  {
//                                     isChecked: row.isCRM,
//                                     onChange: handleSwitchChange('isCRM'), // Pass field name dynamically
//                                  },
//                                  errors,
//                                  'gray.700',
//                                  false, // Not required
//                                  false, // Not disabled
//                               )}
//                            </GridItem>
//                            <GridItem colSpan={{ base: 1, md: 3, xl: 3 }}>
//                               <Grid
//                                  border="1px solid"
//                                  borderColor="gray.200"
//                                  px="20px"
//                                  py="5px"
//                                  borderRadius="md"
//                                  gap={4}>
//                                  <Text>Company Bank 1 Details</Text>
//                                  <Flex gap={5}>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankAccName1',
//                                           'Account Name',
//                                           {
//                                              value: row.bankAccName1,
//                                              onChange: (e) => handleInputChange('bankAccName1', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankAccNo1',
//                                           'Account No',
//                                           {
//                                              value: row.bankAccNo1,
//                                              onChange: (e) => handleInputChange('bankAccNo1', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                  </Flex>
//                                  <Flex gap={5} mb={2}>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankName1',
//                                           'Bank Name',
//                                           {
//                                              value: row.bankName1,
//                                              onChange: (e) => handleInputChange('bankName1', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankIFSC1',
//                                           'Bank IFSC',
//                                           {
//                                              value: row.bankIFSC1,
//                                              onChange: (e) => handleInputChange('bankIFSC1', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                  </Flex>
//                               </Grid>
//                            </GridItem>
//                            <GridItem colSpan={{ base: 1, md: 3, xl: 3 }}>
//                               <Grid
//                                  border="1px solid"
//                                  borderColor="gray.200"
//                                  px="20px"
//                                  py="5px"
//                                  borderRadius="md"
//                                  gap={4}>
//                                  <Text>Company Bank 2 Details</Text>
//                                  <Flex gap={5}>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankAccName2',
//                                           'Account Name',
//                                           {
//                                              value: row.bankAccName2,
//                                              onChange: (e) => handleInputChange('bankAccName2', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankAccNo2',
//                                           'Account No',
//                                           {
//                                              value: row.bankAccNo2,
//                                              onChange: (e) => handleInputChange('bankAccNo2', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                  </Flex>
//                                  <Flex gap={5} mb={2}>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankName2',
//                                           'Bank Name',
//                                           {
//                                              value: row.bankName2,
//                                              onChange: (e) => handleInputChange('bankName2', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                     <GridItem className="seperator-width">
//                                        {DynamicInput(
//                                           'bankIFSC2',
//                                           'Bank IFSC',
//                                           {
//                                              value: row.bankIFSC2,
//                                              onChange: (e) => handleInputChange('bankIFSC2', e.target.value),
//                                           },
//                                           errors,
//                                           textColor,
//                                           false, // isRequired
//                                        )}
//                                     </GridItem>
//                                  </Flex>
//                               </Grid>
//                            </GridItem>
//                         </>
//                      </Grid>
//                   </GridItem>
//                </Grid>
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//               <Button
//                 onClick={handlePrevious}
//                 variant="ghost"
//                 colorScheme="teal"
//                 mr={3}
//               >
//                 Previous
//               </Button>
//             )} */}
//                <Button onClick={() => handleNext()} colorScheme="green" ml={3}>
//                   Save
//                </Button>
//                <Button variant="ghost" onClick={() => handleOnClose()} ml={3}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default CompanyForm;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { Modal, ModalOverlay, ModalContent, useToast, useColorMode } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyDetailsByGst, addCompanyInUI, updateCompany, getCompanies } from '../../../redux/actions/company';
import { getGroupIDs } from '../../../redux/actions/companyGroup';
import './css.css';
import { userProfile } from '../../../redux/actions/user';
import { useGlobal } from '../../../contexts/GlobalContext';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { DynamicInput } from '../../../components/UIcomponents/Dynamicinput';
import { renderSwitchControl } from 'utils/DynamicFormData';
import { Building2, MapPin, Phone, Mail, CreditCard, Landmark, X, Upload, ImageIcon } from 'lucide-react';

const validationSchema = Yup.object().shape({
   name: Yup.string().required('Company Name is required'),
   shortName: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable()
      .min(3, 'Short name must be at least 3 characters long'),
   panNo: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
      .required('PAN is required'),
   address1: Yup.string().required('Address 1 is required'),
   cityId: Yup.mixed().required('City is required'),
   coGroupId: Yup.mixed().required('GroupId is required'),
   gstRegNo: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
   mobile: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
   email: Yup.string()
      .email('Invalid email format')
      .transform((value) => (value === '' ? null : value))
      .nullable(),
   address2: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
   address3: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
   pincode: Yup.string()
      .transform((value) => (value === '' ? null : value))
      .nullable(),
});

const CompanyForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, gstNo }) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const { cityList } = useGlobal();
   const [errors, setErrors] = useState({});
   const [image, setImage] = useState({});
   const textColor = isDark ? 'white' : 'gray.800';
   const coGroupIds = useSelector((state) => state.companyGroup.list);
   const company = useSelector((state) => state.company.gstDetail);
   const fileInputRef = useRef(null);

   const toast = useToast();
   const dispatch = useDispatch();

   const [row, setRow] = useState({
      name: '',
      shortName: '',
      panNo: '',
      gstRegNo: '',
      mobile: '',
      email: '',
      address1: '',
      address2: '',
      address3: '',
      isCRM: false,
      image: null,
      cityId: null,
      pincode: '',
      coGroupId: null,
      bankAccName1: null,
      bankAccName2: null,
      bankAccNo1: null,
      bankAccNo2: null,
      bankIFSC1: null,
      bankIFSC2: null,
      bankName1: null,
      bankName2: null,
   });

   const clearFormData = useCallback(() => {
      setRow({
         name: '',
         shortName: '',
         panNo: '',
         gstRegNo: '',
         mobile: '',
         email: '',
         address1: '',
         address2: '',
         address3: '',
         cityId: null,
         pincode: '',
         isCRM: false,
         image: null,
         coGroupId: null,
         bankAccName1: null,
         bankAccName2: null,
         bankAccNo1: null,
         bankAccNo2: null,
         bankIFSC1: null,
         bankIFSC2: null,
         bankName1: null,
         bankName2: null,
      });
      setImage({});
      setErrors({});
   });

   const handleOnClose = useCallback(() => {
      clearFormData();
      // localStorage.removeItem('gst');
      // window.location.reload();
      onClose();
   }, [clearFormData, onClose]);

   useEffect(() => {
      if (!isOpen) return;

      const handleEscKey = (event) => {
         if (event.key === 'Escape' || event.keyCode === 27) {
            event.preventDefault();
            event.stopPropagation();
            handleOnClose();
         }
      };

      // Use capture phase to intercept before Chakra UI
      window.addEventListener('keydown', handleEscKey, true);

      return () => {
         window.removeEventListener('keydown', handleEscKey, true);
      };
   }, [isOpen, handleOnClose]);

   const handleInputChange = (field, value) => {
      if (field === 'image') {
         const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
         if (!allowedTypes.includes(value.type)) {
            alert('Please upload a valid image (JPEG, PNG, or WEBP)');
            return;
         }

         // Create preview using FileReader
         const reader = new FileReader();
         reader.onloadend = () => {
            setImage({
               value: value,
               preview: reader.result,
               isExisting: false,
            });
         };
         reader.readAsDataURL(value);
      } else {
         setRow((prev) => ({ ...prev, [field]: value }));

         if (field === 'gstRegNo' && value?.toString()?.length === 15) {
            setRow((prev) => ({ ...prev, panNo: value?.slice(2, 12) }));
            dispatch(getCompanyDetailsByGst(value));
         }

         setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors[field]) {
               delete newErrors[field];
            }
            return newErrors;
         });
      }
   };

   const onFormSubmit = async () => {
      try {
         const formData = new FormData();

         // Append all fields from row
         for (const key in row) {
            if (key === 'image') {
               console.log('image data', image, image.value, typeof image.value);
               if (image?.value) {
                  formData.append('image', image.value);
               }
            } else {
               const value = row[key];
               if (value !== null && value !== undefined && value !== '' && value !== 'null') {
                  formData.append(key, value);
               }
            }
         }

         // Add ID if editing
         if (isEditMode && currentRow?.id) {
            formData.append('id', currentRow.id);
            await dispatch(updateCompany(formData));
         } else {
            console.log('formData', formData);
            await dispatch(addCompanyInUI(formData));
         }
         await dispatch(getCompanies());
         await dispatch(userProfile());
         clearFormData();
         localStorage.removeItem('gst');
         window.location.reload();
         onClose();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the company.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleNext = () => {
      try {
         const dataToValidate = {};
         dataToValidate.name = row.name || '';
         dataToValidate.shortName = row.shortName || '';
         dataToValidate.panNo = row.panNo || '';
         dataToValidate.address1 = row.address1 || '';
         dataToValidate.cityId = row.cityId || null;
         dataToValidate.coGroupId = row.coGroupId || null;

         const isValid = validationSchema.validateSync(dataToValidate, { abortEarly: false });

         if (isValid) {
            onFormSubmit();
         }
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            const showMessage = (errorObj) => {
               const values = Object.values(errorObj);
               return values.length ? values[0] : '';
            };

            // Example:
            const msg = showMessage(errorObj);

            toast({
               title: 'Validation Error',
               description: `${msg}`,
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         }
      }
   };

   useEffect(() => {
      if (gstNo) {
         dispatch(getCompanyDetailsByGst(gstNo));
      }
   }, [gstNo, dispatch]);

   useEffect(() => {
      if (coGroupIds?.length <= 0 && isOpen) {
         dispatch(getGroupIDs());
      }
   }, [coGroupIds?.length, dispatch, isOpen]);

   useEffect(() => {
      if (company) {
         const address = company && company.pradr ? company.pradr.addr : {};
         const gstUpper = (gstNo || '').toUpperCase();
         setRow((prev) => ({
            ...prev,
            name: company?.tradeNam,
            gstRegNo: row.gstRegNo || gstUpper,
            address1: `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`,
            cityId: cityList?.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id,
            coGroupId: coGroupIds?.find((group) => group?.name?.toLowerCase() === (company?.lgnm || '').toLowerCase())
               ?.id,
            pincode: address?.pncd,
            panNo: gstUpper?.slice(2, 12),
         }));
      }
   }, [cityList, company, gstNo]);

   useEffect(() => {
      if (isOpen && isEditMode && currentRow) {
         setRow((prev) => ({
            ...prev,
            name: currentRow?.name,
            shortName: currentRow?.shortName,
            panNo: currentRow?.panNo,
            gstRegNo: currentRow?.gstRegNo ?? '',
            mobile: currentRow?.mobile,
            email: currentRow?.email,
            address1: currentRow?.address1,
            address2: currentRow?.address2,
            address3: currentRow?.address3,
            cityId: currentRow?.cityId,
            pincode: currentRow?.pinCode,
            coGroupId: currentRow?.coGroupId,
            isCRM: currentRow?.isCRM,
            image: currentRow?.image,
            bankAccName1: currentRow?.bankAccName1,
            bankAccName2: currentRow?.bankAccName2,
            bankAccNo1: currentRow?.bankAccNo1,
            bankAccNo2: currentRow?.bankAccNo2,
            bankIFSC1: currentRow?.bankIFSC1,
            bankIFSC2: currentRow?.bankIFSC2,
            bankName1: currentRow?.bankName1,
            bankName2: currentRow?.bankName2,
         }));
      }
   }, [currentRow, isEditMode, isOpen]);

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked,
      }));
   };

   const [logoUrl, setLogoUrl] = useState(null);

   // useEffect(() => {
   //    const fetchLogo = async () => {
   //       if (!currentRow?.logo) return;
   //       try {
   //          const token = localStorage.getItem('token'); // or wherever you store it
   //          const res = await axios.get(
   //             `${currentRow.liveUrl}`,
   //             {
   //                headers: { Authorization: `essential` },
   //                responseType: 'blob', // get image as binary blob
   //             }
   //          );
   //          const blobUrl = URL.createObjectURL(res.data);
   //          setLogoUrl(blobUrl);
   //       } catch (error) {
   //          console.error('Error fetching logo:', error);
   //       }
   //    };
   //    fetchLogo();
   //    // cleanup blob when component unmounts
   //    return () => {
   //       if (logoUrl) URL.revokeObjectURL(logoUrl);
   //    };
   // }, [currentRow?.logo]);

   return (
      <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" closeOnEsc={true}>
         <ModalOverlay className="backdrop-blur-sm bg-black/30" />
         <ModalContent
            className={`${isDark ? 'bg-gray-900' : 'bg-white'} rounded-2xl shadow-2xl border ${
               isDark ? 'border-gray-700' : 'border-gray-200'
            }`}
            tabIndex={0}
            style={{ maxHeight: '90vh', margin: '2vh auto' }}>
            {/* Header */}
            <div className={`px-8 pt-8 pb-6 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
               <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                     <div
                        className={`p-3 rounded-xl ${
                           isDark
                              ? 'bg-gradient-to-br from-blue-500/20 to-purple-500/20'
                              : 'bg-gradient-to-br from-blue-50 to-purple-50'
                        }`}>
                        <Building2 className={`w-6 h-6 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                     </div>
                     <div>
                        <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {isEditMode ? 'Edit Company' : 'Add New Company'}
                        </h2>
                        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'} mt-0.5`}>
                           {isEditMode ? 'Update company information' : 'Enter company details to continue'}
                        </p>
                     </div>
                  </div>
                  <button
                     onClick={handleOnClose}
                     className={`p-2 rounded-lg transition-all hover:rotate-90 ${
                        isDark ? 'hover:bg-gray-800 text-gray-400' : 'hover:bg-gray-100 text-gray-600'
                     }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>
            </div>

            {/* Body */}
            <div className="px-8 py-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 200px)' }}>
               {/* Company Details Section */}
               <div
                  className={`mb-8 rounded-2xl border-2 ${
                     isDark
                        ? 'border-blue-500/30 bg-gradient-to-br from-blue-500/5 to-purple-500/5'
                        : 'border-blue-200 bg-gradient-to-br from-blue-50/50 to-purple-50/50'
                  }`}>
                  <div className={`px-6 py-4 border-b ${isDark ? 'border-blue-500/20' : 'border-blue-200'}`}>
                     <div className="flex items-center space-x-3">
                        <Building2 className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                        <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Company Information
                        </h3>
                     </div>
                  </div>

                  <div className="p-6">
                     <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                        <div className="col-span-1">
                           {DynamicInput(
                              'gstRegNo',
                              'GST NO',
                              {
                                 value: row.gstRegNo,
                                 onChange: (e) => handleInputChange('gstRegNo', e.target.value.toUpperCase()),
                              },
                              errors,
                              textColor,
                              'text',
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'name',
                              'Company Name',
                              {
                                 value: row.name,
                                 onChange: (e) => handleInputChange('name', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              true,
                           )}
                        </div>
                        <div className="col-span-1">
                           {DynamicInput(
                              'shortName',
                              'Short Name',
                              {
                                 value: row.shortName,
                                 onChange: (e) => handleInputChange('shortName', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'panNo',
                              'Pan No',
                              {
                                 value: row.panNo,
                                 onChange: (e) => handleInputChange('panNo', e.target.value.toUpperCase()),
                              },
                              errors,
                              textColor,
                              'text',
                              true,
                           )}
                        </div>
                        <div className="col-span-1">
                           {DynamicInput(
                              'mobile',
                              'Mobile',
                              {
                                 value: row.mobile,
                                 onChange: (e) => handleInputChange('mobile', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'email',
                              'Email',
                              {
                                 value: row.email,
                                 onChange: (e) => handleInputChange('email', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {renderDynamicDropdown(
                              'coGroupId',
                              'Group ID',
                              coGroupIds,
                              {
                                 value: row.coGroupId,
                                 onChange: (value) => handleInputChange('coGroupId', value),
                              },
                              errors,
                              textColor,
                              true,
                              'Select Company Group',
                           )}
                        </div>

                        <div className="col-span-1">
                           {renderSwitchControl(
                              'isCRM',
                              'Allow CRM Access',
                              {
                                 isChecked: row.isCRM,
                                 onChange: handleSwitchChange('isCRM'),
                              },
                              errors,
                              'gray.700',
                              false,
                              false,
                           )}
                        </div>
                        <div className="flex flex-col items-center justify-center w-full col-span-1">
                           <div className="relative w-32 h-32 flex items-center justify-center bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl overflow-hidden hover:border-blue-400 transition-all duration-200 group shadow-sm">
                              {/* Image Preview (last uploaded) */}
                              {currentRow?.logo && currentRow?.liveUrl && currentRow?.liveUrl && !image?.preview ? (
                                 <img
                                    src={currentRow?.liveUrl}
                                    // src={logoUrl}
                                    // src={currentRow?.liveUrl}
                                    // src={`http://192.168.29.169:7790/assets/company/${currentRow?.logo}`}
                                    crossOrigin="anonymous"
                                    alt="Logo"
                                    className="w-full h-full object-cover rounded-lg"
                                 />
                              ) : image?.preview ? (
                                 <img
                                    src={image.preview}
                                    alt="Preview"
                                    className="mt-2 w-20 h-20 object-cover rounded border"
                                 />
                              ) : (
                                 <div className="flex flex-col items-center text-gray-400">
                                    <ImageIcon size={36} />
                                    <span className="text-sm mt-1">No Logo</span>
                                 </div>
                              )}

                              {/* Hover Overlay */}
                              <div
                                 className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-all duration-300 cursor-pointer"
                                 onClick={() => fileInputRef.current?.click()}>
                                 <div className="flex flex-col items-center text-white">
                                    <Upload size={28} />
                                    <span className="text-sm mt-1">Upload New</span>
                                 </div>
                              </div>
                           </div>

                           {/* Hidden File Input */}
                           <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              className="hidden"
                              onChange={(e) => {
                                 const file = e.target.files[0];
                                 console.log('file', file);
                                 if (file) {
                                    handleInputChange('image', file); // same logic you already use
                                 }
                              }}
                           />

                           {/* Optional file name preview */}
                           {image?.value && (
                              <p className="mt-2 text-sm text-gray-500 truncate max-w-[8rem]">{image.value.name}</p>
                           )}
                        </div>
                     </div>
                  </div>
               </div>

               {/* Address Section */}
               <div
                  className={`mb-8 rounded-2xl border-2 ${
                     isDark
                        ? 'border-emerald-500/30 bg-gradient-to-br from-emerald-500/5 to-teal-500/5'
                        : 'border-emerald-200 bg-gradient-to-br from-emerald-50/50 to-teal-50/50'
                  }`}>
                  <div className={`px-6 py-4 border-b ${isDark ? 'border-emerald-500/20' : 'border-emerald-200'}`}>
                     <div className="flex items-center space-x-3">
                        <MapPin className={`w-5 h-5 ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`} />
                        <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Address Details
                        </h3>
                     </div>
                  </div>

                  <div className="p-6">
                     <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                        <div className="col-span-1">
                           {DynamicInput(
                              'address1',
                              'Address 1',
                              {
                                 value: row.address1,
                                 onChange: (e) => handleInputChange('address1', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              true,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'address2',
                              'Address 2',
                              {
                                 value: row.address2,
                                 onChange: (e) => handleInputChange('address2', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'address3',
                              'Address 3',
                              {
                                 value: row.address3,
                                 onChange: (e) => handleInputChange('address3', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {renderDynamicDropdown(
                              'city',
                              'City',
                              cityList,
                              {
                                 value: row.cityId,
                                 onChange: (value) => handleInputChange('cityId', value),
                                 showCustomNoOptions: true,
                                 openfrom: 'city',
                              },
                              errors,
                              textColor,
                              true,
                              'Select City',
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'pincode',
                              'Pincode',
                              {
                                 value: row.pincode,
                                 onChange: (e) => handleInputChange('pincode', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>
                     </div>
                  </div>
               </div>

               {/* Bank Account 1 */}
               <div
                  className={`mb-8 rounded-2xl border-2 ${
                     isDark
                        ? 'border-violet-500/30 bg-gradient-to-br from-violet-500/5 to-fuchsia-500/5'
                        : 'border-violet-200 bg-gradient-to-br from-violet-50/50 to-fuchsia-50/50'
                  }`}>
                  <div className={`px-6 py-4 border-b ${isDark ? 'border-violet-500/20' : 'border-violet-200'}`}>
                     <div className="flex items-center space-x-3">
                        <Landmark className={`w-5 h-5 ${isDark ? 'text-violet-400' : 'text-violet-600'}`} />
                        <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Bank Account 1 Details
                        </h3>
                     </div>
                  </div>

                  <div className="p-6">
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <div className="col-span-1">
                           {DynamicInput(
                              'bankAccName1',
                              'Account Name',
                              {
                                 value: row.bankAccName1,
                                 onChange: (e) => handleInputChange('bankAccName1', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankAccNo1',
                              'Account No',
                              {
                                 value: row.bankAccNo1,
                                 onChange: (e) => handleInputChange('bankAccNo1', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankName1',
                              'Bank Name',
                              {
                                 value: row.bankName1,
                                 onChange: (e) => handleInputChange('bankName1', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankIFSC1',
                              'Bank IFSC',
                              {
                                 value: row.bankIFSC1,
                                 onChange: (e) => handleInputChange('bankIFSC1', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>
                     </div>
                  </div>
               </div>

               {/* Bank Account 2 */}
               <div
                  className={`rounded-2xl border-2 ${
                     isDark
                        ? 'border-amber-500/30 bg-gradient-to-br from-amber-500/5 to-orange-500/5'
                        : 'border-amber-200 bg-gradient-to-br from-amber-50/50 to-orange-50/50'
                  }`}>
                  <div className={`px-6 py-4 border-b ${isDark ? 'border-amber-500/20' : 'border-amber-200'}`}>
                     <div className="flex items-center space-x-3">
                        <CreditCard className={`w-5 h-5 ${isDark ? 'text-amber-400' : 'text-amber-600'}`} />
                        <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Bank Account 2 Details
                        </h3>
                     </div>
                  </div>

                  <div className="p-6">
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <div className="col-span-1">
                           {DynamicInput(
                              'bankAccName2',
                              'Account Name',
                              {
                                 value: row.bankAccName2,
                                 onChange: (e) => handleInputChange('bankAccName2', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankAccNo2',
                              'Account No',
                              {
                                 value: row.bankAccNo2,
                                 onChange: (e) => handleInputChange('bankAccNo2', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankName2',
                              'Bank Name',
                              {
                                 value: row.bankName2,
                                 onChange: (e) => handleInputChange('bankName2', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>

                        <div className="col-span-1">
                           {DynamicInput(
                              'bankIFSC2',
                              'Bank IFSC',
                              {
                                 value: row.bankIFSC2,
                                 onChange: (e) => handleInputChange('bankIFSC2', e.target.value),
                              },
                              errors,
                              textColor,
                              false,
                           )}
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Footer */}
            <div
               className={`px-8 py-6 border-t ${
                  isDark ? 'border-gray-700' : 'border-gray-200'
               } flex justify-end space-x-3`}>
               <button
                  onClick={handleOnClose}
                  className={`px-6 py-2.5 rounded-xl font-medium transition-all ${
                     isDark
                        ? 'bg-gray-800 hover:bg-gray-700 text-gray-300'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                  }`}>
                  Cancel
               </button>
               <button
                  onClick={handleNext}
                  className={`px-6 py-2.5 rounded-xl font-medium transition-all shadow-lg ${
                     isDark
                        ? 'bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white'
                        : 'bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white'
                  }`}>
                  Save Company
               </button>
            </div>
         </ModalContent>
      </Modal>
   );
};

export default CompanyForm;
